export default [
  {
    header: 'Dashboards',
    icon: 'HomeIcon',
    route: 'dashboard',
  },
]
